import { createFileRoute } from "@tanstack/react-router";

import { PrincipalPage } from "../../../workspaces/label/pages/PrincipalPage";

export const Route = createFileRoute("/_console/label/principal")({
  component: PrincipalPage,
});
